import { motion } from "framer-motion";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Container,
} from "@mui/material";
import { LocationOn, Phone, Email, Schedule } from "@mui/icons-material";

export default function ContactSectionLN() {
  return (
    <Box
      component="section"
      id="contact"
      sx={{
        backgroundColor: "#FAF8F3", // var(--brand-cream)
        py: { xs: 8, md: 10 },
      }}
    >
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          style={{ textAlign: "center", marginBottom: "4rem" }}
        >
          <Typography
            variant="h2"
            sx={{
              fontFamily: "'Fjalla One', sans-serif",
              fontSize: { xs: "36px", md: "48px" }, // 48px on desktop, slightly smaller on mobile
              fontWeight: "bold",
              color: "#e25822",
              textTransform: "uppercase",
              mb: "20px",
              textAlign: "center",
              display: "block",
            }}
          >
            Contact Us
          </Typography>
          {/* <Typography
            sx={{
              fontSize: "1.25rem",
              color: "#2E261C", // var(--brand-dark)
              maxWidth: "32rem",
              mx: "auto",
            }}
          >
            We would love to hear from you! Whether you have questions about our
            events, need assistance with registration, or just want to say
            hello, feel free to reach out.
          </Typography> */}
        </motion.div>

        <Box
          sx={{
            display: "grid",
            gap: "3rem",
            gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
          }}
        >
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <Card
              sx={{
                boxShadow: 3,
                border: "2px solid #D2B48C", // var(--brand-tan)
                height: "100%",
              }}
            >
              <CardHeader
                title={"Get in Touch"}
                sx={{
                  backgroundColor: "#A0845C",
                  color: "#FAF8F3",
                  "& .MuiCardHeader-title": {
                    fontSize: "1.5rem",
                    fontFamily: "Playfair Display, serif",
                  },
                }}
              />
              <CardContent
                sx={{
                  backgroundColor: "white",
                  height: 320,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: 2,
                }}
              >
                {[
                  {
                    icon: (
                      <LocationOn
                        sx={{ color: "#8B7355", width: 24, height: 24 }}
                      />
                    ),
                    text: "Hotel Rtanj, Kopaonik",
                  },
                  {
                    icon: (
                      <Phone sx={{ color: "#8B7355", width: 24, height: 24 }} />
                    ),
                    text: "+381 600 22 88 19",
                  },
                  {
                    icon: (
                      <Email sx={{ color: "#8B7355", width: 24, height: 24 }} />
                    ),
                    text: "race@serbiantrophy.rs",
                  },
                ].map(({ icon, text }, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                      color: "#2E261C",
                    }}
                  >
                    {icon}
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "1.25rem",
                        color: "#2E261C",
                      }}
                    >
                      {text}
                    </Typography>
                  </Box>
                ))}
              </CardContent>
            </Card>
          </motion.div>

          {/* Map */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <Card
              sx={{
                boxShadow: 3,
                border: "2px solid #D2B48C",
                height: "100%",
              }}
            >
              <CardHeader
                title={"Find Us Here"}
                sx={{
                  backgroundColor: "#A0845C",
                  color: "#FAF8F3",
                  "& .MuiCardHeader-title": {
                    fontSize: "1.5rem",
                    fontFamily: "Playfair Display, serif",
                  },
                }}
              />
              <CardContent sx={{ p: 0, backgroundColor: "white" }}>
                <Box
                  sx={{
                    width: "100%",
                    height: 320,
                  }}
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2904.1292365013787!2d20.817215275982157!3d43.290615171121566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47563dd60073c3fd%3A0xd851cbbb37d3ff8f!2z0KDRgtCw0Zo!5e0!3m2!1sen!2srs!4v1757507575069!5m2!1sen!2srs"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Hotel Rtanj, Kopaonik"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: 0,
                      borderRadius: "0 0 8px 8px",
                    }}
                  />
                </Box>
              </CardContent>
            </Card>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
}
